export const EVENT_COMMUNICATION_NAMESPACE = {
    REALIZE_OVERVIEW_RRS: 'REALIZE_OVERVIEW_RRS_NS',
};
export var EventAction;
(function (EventAction) {
    EventAction["LOAD_COMPLETE"] = "LOAD_COMPLETE";
})(EventAction || (EventAction = {}));
